import React from "react";
import { Link } from "react-router-dom";
import { products } from "../../data/products";
import "../../styles/MadhumehShowcase.css";
import madhu from "../../assets/images/madhu.jpeg";
const MadhumehShowcase = () => {
  const madhumehProduct = products.find((p) => p.id === 1);

  const benefits = [
    "Helps regulate blood sugar levels",
    "Supports healthy insulin response",
    "Improves metabolism and digestion",
    "100% Ayurvedic herbal formulation",
    "Boosts daily energy and stamina",
    "Safe for daily use",
  ];

  return (
    <section className="madhumeh-showcase">
      <div className="madhumeh-container">
        <div className="madhumeh-content">
          <span className="madhumeh-tag">Madhumeh (Sugar) Care Powder</span>
          <h1 className="madhumeh-title">Madhumeh Care Powder</h1>
          <p className="madhumeh-subtitle">
            Natural Ayurvedic Solution for Healthy Blood Sugar Management{" "}
          </p>
          <p className="madhumeh-description">
            Madhumeh (Sugar) Care Powder is a scientifically formulated
            Ayurvedic herbal blend designed to support healthy blood sugar
            levels naturally. Made with powerful traditional herbs, it helps
            improve glucose metabolism, supports insulin function, and promotes
            overall wellness.
          </p>
          <ul className="benefits-list">
            {benefits.map((item, i) => (
              <li key={i}>{item}</li>
            ))}
          </ul>

          <div className="madhumeh-footer">
            <div className="price-box">
              ₹ {madhumehProduct.price}
              <span>₹ {madhumehProduct.oldPrice}</span>
            </div>

            <Link
              to={`/products/${madhumehProduct.slug}`}
              className="madhumeh-btn"
            >
              Buy Now
            </Link>
          </div>
        </div>
        <div className="madhumeh-image">
          <img src={madhu} alt="Madhumeh Care Powder" />
        </div>
      </div>
    </section>
  );
};

export default MadhumehShowcase;
